
export class Pagos {
    id: number;
    idCxc: number;
    fecha: Date;
    fechaPago: string;
    idCliente: string;
    valor: number;
    saldo: number;
    formaPago: string;
    documento: string;
    idEmisor:number;
    enviado:string;
    }
    